import Vue from 'vue'
import { HTTP } from '@/utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format'
import { UserRoleEnum } from '@/enums/userRolesEnum'
import GenericModal from '@/componentsReusable/genericModal.vue'
import { convertDateStringToUTCDate } from '@/utils/dateUtil'

export default Vue.component('provider-availabilities-card', {
  name: 'AvailabilityCard',
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewAvailability: false,
      providerAvailabilities: [] as any[],
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteAvailability: null,
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal,
    flatPickr
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'MMM D, YYYY');
      return tempString;
    },
    availableFormat (isAvailable: any) {
      return isAvailable ? 'Available' : 'Not Available';
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getProviderAvailabilities();
      }
    },
    getProviderAvailabilities () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/providers/' + this.$route.params.providerId + '/availabilities')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Provider Availabilities.");          
        }
        let freshProviderAvailabilities = response.data.data;
        freshProviderAvailabilities.forEach( function (providerAvailability: any) {
          providerAvailability.isEditing = false;
          providerAvailability.isNew = false;
          providerAvailability.updatingData = false;
          providerAvailability.isAvailableString = providerAvailability.isAvailable ? "true" : "false";
          providerAvailability.startDate = convertDateStringToUTCDate(providerAvailability.startDate);
          providerAvailability.endDate = convertDateStringToUTCDate(providerAvailability.endDate);
        });

        self.providerAvailabilities = freshProviderAvailabilities;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Provider Availabilities.'
        });
      })
    },
    availabilityChange (availability: any, event: any) {
      availability.isAvailable = availability.isAvailableString === 'true' ? true : false;
    },
    saveAvailability (newAvailability: any) {
      let self = this
      self.savingNewAvailability = true;
      // newAvailability.isWelcomed = newAvailability.isWelcomed === 'true' ? true : false;
      HTTP.post('/api/providers/' + this.$route.params.providerId + '/availabilities', newAvailability)
      .then(function (response) {
        self.savingNewAvailability = false;
        newAvailability.isEditing = false;
        self.getProviderAvailabilities();
      })
      .catch(function (error) {
        self.savingNewAvailability = false;

        // newAvailability.idErrorMessage = getRestParamErrorMessage(error, 'id');
        newAvailability.isAvailableErrorMessage = getRestParamErrorMessage(error, 'isAvailable');
        newAvailability.startDateErrorMessage = getRestParamErrorMessage(error, 'startDate');
        newAvailability.endDateErrorMessage = getRestParamErrorMessage(error, 'endDate');
        newAvailability.noteErrorMessage = getRestParamErrorMessage(error, 'note');

        if (
          !newAvailability.isAvailableErrorMessage.length &&
          !newAvailability.startDateErrorMessage.length && 
          !newAvailability.endDateErrorMessage.length && 
          !newAvailability.noteErrorMessage.length 
        ) {            
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving availability.',
            // duration: 5000
          });
        }

      })
    },
    updateAvailability (updatedAvailability: any) {
      let self = this
      updatedAvailability.updatingData = true;
      HTTP.put('/api/providers/' + this.$route.params.providerId + '/availabilities', updatedAvailability)
      .then(function (response) {
        updatedAvailability.updatingData = false;
        updatedAvailability.isEditing = false;
        self.getProviderAvailabilities();
      })
      .catch(function (error) {
        updatedAvailability.updatingData = false;
        
        updatedAvailability.isAvailableErrorMessage = getRestParamErrorMessage(error, 'isAvailable');
        updatedAvailability.startDateErrorMessage = getRestParamErrorMessage(error, 'startDate');
        updatedAvailability.endDateErrorMessage = getRestParamErrorMessage(error, 'endDate');
        updatedAvailability.noteErrorMessage = getRestParamErrorMessage(error, 'note');

        if (
          !updatedAvailability.isAvailableErrorMessage.length &&
          !updatedAvailability.startDateErrorMessage.length && 
          !updatedAvailability.endDateErrorMessage.length && 
          !updatedAvailability.noteErrorMessage.length ) {            
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating availability.',
            // duration: 5000
          });
        }

      })
    },
    deleteConfirmed (deleteAvailability: any) {
      this.showConfirmationModal = false;
      this.deleteAvailability(this.pendingDeleteAvailability, true);      
    },
    deleteAvailability (deleteAvailability: any, bypassDeleteConfirmation: boolean = false) {
      // To prevent a double submit
      if (deleteAvailability.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingDeleteAvailability = deleteAvailability;
        return;
      } else {
        this.pendingDeleteAvailability = null;
      }

      console.log("not returning.");
      let self = this
      deleteAvailability.updatingData = true;
      HTTP.delete('/api/providers/' + this.$route.params.providerId + '/availabilities/' + deleteAvailability.id)
      .then(function (response) {
        deleteAvailability.updatingData = false;
        deleteAvailability.isEditing = false;
        self.getProviderAvailabilities();
      })
      .catch(function (error) {
        deleteAvailability.updatingData = false;
           
        let generalError = getRestResponseErrorMessage(error);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Deleting',
          text: generalError ? generalError : 'An error occurred deleting availability.',
          // duration: 5000
        });
        // }

      })
    },
    toggleEditAvailability (availability: any) {
      let selectedAvailabilityId = availability.id;
      // Collapse any editing availabilities
      // Delete any existing "new" availabilities
      let indexesToDelete: any = [];
      this.providerAvailabilities.forEach(function (availability: any, index: number) {
        if (availability.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedAvailabilityId !== availability.id) {
          availability.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.providerAvailabilities.splice(indx,1);
      })
      availability.isEditing = !availability.isEditing;
    },
    addAvailability () {
      // Collapse any editing availabilities
      // Delete any existing "new" availabilities
      let indexesToDelete: any = [];
      this.providerAvailabilities.forEach(function (availability: any, index: number) {
        if (availability.isNew) {
          indexesToDelete.push(index);
        }
        availability.isEditing = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.providerAvailabilities.splice(indx,1);
      })

      let newAvailability = {
        id: -1,
        isAvailable: true,
        isAvailableString: "true",
        startDate: new Date(),
        endDate: new Date(),
        note: '',
        isEditing: true,
        isNew: true,
        updatingData: false
      };

      this.providerAvailabilities.unshift(newAvailability);
    },
    cancel (availability: any) {
      availability.isEditing = false;
      if (availability.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.providerAvailabilities.shift();
        }, 300);
      } else {
        this.getProviderAvailabilities();
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/availability/AvailabilityCard.ts